exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articleModal[data-v-00e8278f]{z-index:333 !important}", ""]);

// exports
